import React, {FC} from 'react';

import {cn} from '@bem-react/classname';
import {Text} from '@gravity-ui/uikit';
import {QuestionType} from 'common/constants/survey';
import i18n from 'ui/i18n';

import {ChoiceResultsItem, StringResultsItem} from '../../../common/models/success';
import AnswerOption from '../AnswerOption';

import {QuestionResultsProps} from './QuestionResults.types';

import './QuestionResults.scss';

const cnQuestionResults = cn('QuestionResults');

const QuestionResults: FC<QuestionResultsProps> = ({type, items, value, widget}) => {
    if (!items) {
        return null;
    }

    switch (type) {
        case QuestionType.Enum:
        case QuestionType.OneRow:
        case QuestionType.Radio:
        case QuestionType.Stars:
        case QuestionType.Checkbox: {
            const selectedIds = (value as ChoiceResultsItem[]).map((option) => option.id);
            return (
                <>
                    {(items as ChoiceResultsItem[]).map((option) => (
                        <AnswerOption
                            key={option.id}
                            type={type}
                            text={option.label}
                            correct={Boolean(option.scores)}
                            selected={selectedIds.includes(option.id)}
                            widget={widget}
                        />
                    ))}
                </>
            );
        }
        case QuestionType.String: {
            const correctValue = (items as StringResultsItem[])?.[0]?.label;
            return (
                <>
                    <AnswerOption
                        type={type}
                        text={value as string}
                        correct={Number(correctValue) === Number(value)}
                    />
                    {correctValue && (
                        <Text
                            variant="body-2"
                            color="secondary"
                            className={cnQuestionResults('CorrectNumber')}
                        >
                            {i18n('success-page', 'correct-answer', {value: Number(correctValue)})}
                        </Text>
                    )}
                </>
            );
        }
        default:
            return null;
    }
};

export default QuestionResults;
